import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { isNative } from '@/native'

// Gap between taps in a multi-buzz pattern: long enough to count, short enough to feel like one gesture.
const GAP_MS = 110

let pending: ReturnType<typeof setTimeout>[] = []

/**
 * `count` distinct taps from the Taptic Engine. Fire-and-forget: it never blocks the UI, and a
 * new call cancels any taps still queued from the last one (so fast tapping doesn't stack up).
 * No-op on the web.
 */
export function buzz(count: number): void {
  if (!isNative || count < 1) return
  for (const t of pending) clearTimeout(t)
  pending = []
  const tap = () => void Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {})
  tap()
  for (let i = 1; i < count; i++) pending.push(setTimeout(tap, i * GAP_MS))
}
